<template>
  <div class="tabs-list">
    <div class="tabs-bg">
      <svg-icon icon-class="how_to_play_tabs_bg" class-name="bg-svg"></svg-icon>
    </div>
    <div class="tab-item" :class="{ 'is-active': value === tab.value, 'is-disabled': tab.disabled }" v-for="tab in tabs"
      :key="tab.value" @click="(ev) => handleTabClick(tab, tab.value, ev)">
      <div class="tab-label">
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentName: this.value,
    }
  },
  mounted() { },
  methods: {
    handleTabClick(tab, tabName, event) {
      if (tab.disabled) return;
      this.setCurrentName(tabName);
      this.$emit('tab-click', tab, event);
    },
    setCurrentName(value) {
      this.currentName = value;
      this.$emit('input', value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>